import { render, staticRenderFns } from "./NewProductGroup.vue?vue&type=template&id=5b237e97&scoped=true&"
import script from "./NewProductGroup.vue?vue&type=script&lang=js&"
export * from "./NewProductGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b237e97",
  null
  
)

export default component.exports